import { inject, Injectable } from '@angular/core';
import { isUtk } from '@lentau/ui-kit/core/helpers/isBrand.helper';
import { DEFAULT_CITY_SLUG } from '@lentau/city/shared/constants';
import { CityNavigateHelperService } from './city-navigate-helper.service';
import { CityStoreFacade } from '@lentau/city/store/city.facade';
import { CitySlugCacheService } from './city-slug-cache.service';

@Injectable({
  providedIn: 'root',
})
export class CitySlugCacheFacade {
  private cityFacade: CityStoreFacade = inject(CityStoreFacade);
  private cityNavigateHelperService: CityNavigateHelperService = inject(CityNavigateHelperService);
  private citySlugCacheService: CitySlugCacheService = inject(CitySlugCacheService);

  public init(): void {
    this.cityFacade.setCitySlug(this.getCitySlug());
  }

  private getCitySlug(): string {
    if (isUtk()) {
      return DEFAULT_CITY_SLUG;
    }

    const citySlugByUrl: string | null = this.cityNavigateHelperService.regionByUrl;
    const cacheCitySlug: string = this.citySlugCacheService.getInitCitySlug();
    const urlHasCitySlug: boolean = this.cityNavigateHelperService.urlHasCitySlug;

    if (urlHasCitySlug && citySlugByUrl !== cacheCitySlug) {
      this.citySlugCacheService.updateCacheCitySlug(citySlugByUrl);
    }

    return this.citySlugCacheService.getInitCitySlug();
  }
}
